import type { PropsWithChildren } from 'react';
import { useParams } from 'react-router-dom';

import { Loading } from '@/components/ui/old/Loading';

import { useAssetsFilters } from '../hooks/use-assets-filters';
import { CurrentAssetsContext } from '../providers/current-assets';
import { CurrentStaticDataContext } from '../providers/current-static-data';
import { GetAllAssets } from '../queries/get-all-assets';
import { GetStaticData } from '../queries/get-static-data';

export type MapDataLoaderProps = PropsWithChildren<{}>;

export function MapDataLoader({ children }: MapDataLoaderProps) {
  const { siteId } = useParams<{ siteId: string }>();
  const [assetsFilters] = useAssetsFilters();

  const staticData = GetStaticData.useQuery({
    siteId,
    date: assetsFilters.date,
  });
  const assets = GetAllAssets.useQuery({
    siteId,
    assetsFilters,
  });

  if (staticData.isLoading) {
    return <Loading />;
  }

  if (assets.isLoading) {
    return <Loading />;
  }

  if (staticData.isError || !staticData.data) {
    throw staticData.error;
  }

  if (assets.isError || !assets.data) {
    throw assets.error;
  }

  return (
    <CurrentStaticDataContext.Provider value={[staticData.data, staticData]}>
      <CurrentAssetsContext.Provider value={[assets.data, assets]}>
        {children}
      </CurrentAssetsContext.Provider>
    </CurrentStaticDataContext.Provider>
  );
}
